import { RequiredFieldTooltip } from '@/shared/components/required-field-tooltip';
import { Field } from '@noorden-insurtech/alba-design-system';
import type { TFieldContext } from '../types';

export type NumberFieldProps = {
  label: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number | string;
};

export function createNumberField(useFieldContext: () => unknown) {
  return function NumberField({
    label,
    placeholder,
    required,
    helperText,
    disabled,
    min,
    max,
    step,
  }: NumberFieldProps) {
    const field = useFieldContext() as TFieldContext<string>;

    return (
      <RequiredFieldTooltip active={required}>
        <Field.Root invalid={!!field.state.meta.errors.length}>
          <Field.Label>
            {label}
            {required && <span className='text-alba-error-red-500'>*</span>}
          </Field.Label>
          <Field.Input
            type='number'
            value={field.state.value || ''}
            onChange={e => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
            placeholder={placeholder}
            disabled={disabled}
            min={min}
            max={max}
            step={step}
          />
          {helperText && !field.state.meta.errors.length && (
            <Field.HelperText>{helperText}</Field.HelperText>
          )}
          {field.state.meta.errors.length > 0 && (
            <Field.ErrorText>{field.state.meta.errors[0]}</Field.ErrorText>
          )}
        </Field.Root>
      </RequiredFieldTooltip>
    );
  };
}
